import  * as yup from "yup";
export const CreateOrderSchema = yup.object({
  case_id: yup
    .string()
    .required(`Case ID is required`),
    order_type: yup
    .string()
    .required(`Order Type is required`),
    po_number: yup
    .string(),
    qty: yup
    .number(),
});
